import useRootStore from './useRootStore';

export default function useClosedSearchEvent() {
  const { closedSearchEventStore } = useRootStore();
  return closedSearchEventStore;
}
